'use client'
"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    withSVGAttributes: ()=>withSVGAttributes,
    default: ()=>SVG_withSVGAttributes
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_react_namespaceObject = require("react");
const svgProps = {
    viewBox: '0 0 24 24',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    focusable: 'false',
    'aria-hidden': 'true'
};
function withSVGAttributes(Component) {
    const displayName = Component.displayName || Component.name || 'Component';
    const WrappedComponent = /*#__PURE__*/ (0, external_react_namespaceObject.forwardRef)((props, ref)=>{
        const mergedProps = {
            ...props,
            ...svgProps,
            ref
        };
        return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(Component, {
            ...mergedProps
        });
    });
    WrappedComponent.displayName = `withSVGAttributes(${displayName})`;
    return WrappedComponent;
}
const SVG_withSVGAttributes = withSVGAttributes;
exports["default"] = __webpack_exports__["default"];
exports.withSVGAttributes = __webpack_exports__.withSVGAttributes;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "default",
    "withSVGAttributes"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
